import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';
import { tStatic } from '@/i18n';

/**
 * Wordmark set in the condensed display face, matching the reference's logo
 * treatment. Rendered as text so it inherits the theme and stays crisp.
 */
export function Logo({
  className,
  as = 'link',
  to = '/',
}: {
  className?: string;
  as?: 'link' | 'text';
  to?: string;
}) {
  const mark = (
    <span
      // Sized down from the four-letter mark it replaced: eight characters in
      // a condensed face crowd the header against the language picker and the
      // theme toggle on a 320px screen.
      className={cn(
        'display text-[1.375rem] leading-none tracking-[-0.02em] text-ink sm:text-[1.75rem]',
        className,
      )}
    >
      BOOMSHOT
    </span>
  );

  if (as === 'text') return mark;

  return (
    <Link to={to} className="inline-flex items-center rounded-xs" aria-label={tStatic('brand.home')}>
      {mark}
    </Link>
  );
}

/** Square app mark used for favicons, share cards and the install icon. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={cn('size-8', className)}
      role="img"
      aria-label="BOOMSHOT"
      fill="none"
    >
      <rect width="64" height="64" rx="14" fill="var(--accent)" />
      {/* A single open eye-ring: watched once, then closed. */}
      <circle cx="32" cy="32" r="13" stroke="var(--accent-ink)" strokeWidth="4.5" />
      <circle cx="32" cy="32" r="4.5" fill="var(--accent-ink)" />
    </svg>
  );
}
